import request from '@/utils/request'

/**
 * 获取订单列表
 * @param params
 */
export function getOrderList(params) {
    return request({
        url: process.env.PAY_API + '/order/getPageList',
        method: 'post',
        data: params
    })
}

/**
 * 获取订单详情
 * @param params
 */
export function getOrderById(params) {
    return request({
        url: process.env.WEB_API + '/order/getDetail',
        method: 'post',
        data: params
    })
} 


// WEBPACK FOOTER //
// ./src/api/order.js